function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["point", "line"],
  _excluded2 = ["params", "projection", "mark", "name", "encoding"];
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { isObject } from 'vega-util';
import { normalizeEncoding } from '../encoding';
import { isMarkDef } from '../mark';
import { isUnitSpec } from '../spec/unit';
import { stack } from '../stack';
import { keys, omit, pick } from '../util';
import { initMarkdef } from '../compile/mark/init';
function dropLineAndPoint(markDef) {
  var _point = markDef.point,
    _line = markDef.line,
    mark = _objectWithoutProperties(markDef, _excluded);
  return keys(mark).length > 1 ? mark : mark.type;
}
function dropLineAndPointFromConfig(config) {
  for (var _i = 0, _arr = ['line', 'area', 'rule', 'trail']; _i < _arr.length; _i++) {
    var mark = _arr[_i];
    if (config[mark]) {
      config = _objectSpread(_objectSpread({}, config), {}, _defineProperty({}, mark, omit(config[mark], ['point', 'line'])));
    }
  }
  return config;
}
function getPointOverlay(markDef) {
  var markConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var encoding = arguments.length > 2 ? arguments[2] : undefined;
  if (markDef.point === 'transparent') {
    return {
      opacity: 0
    };
  } else if (markDef.point) {
    // truthy : true or object
    return isObject(markDef.point) ? markDef.point : {};
  } else if (markDef.point !== undefined) {
    // false or null
    return null;
  } else {
    // undefined (not disabled)
    if (markConfig.point || encoding.shape) {
      // enable point overlay if config[mark].point is truthy or if encoding.shape is provided
      return isObject(markConfig.point) ? markConfig.point : {};
    }
    // markDef.point is defined as falsy
    return undefined;
  }
}
function getLineOverlay(markDef) {
  var markConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (markDef.line) {
    // true or object
    return markDef.line === true ? {} : markDef.line;
  } else if (markDef.line !== undefined) {
    // false or null
    return null;
  } else {
    // undefined (not disabled)
    if (markConfig.line) {
      // enable line overlay if config[mark].line is truthy
      return markConfig.line === true ? {} : markConfig.line;
    }
    // markDef.point is defined as falsy
    return undefined;
  }
}
export var PathOverlayNormalizer = /*#__PURE__*/function () {
  function PathOverlayNormalizer() {
    _classCallCheck(this, PathOverlayNormalizer);
    this.name = 'path-overlay';
  }
  return _createClass(PathOverlayNormalizer, [{
    key: "hasMatchingType",
    value: function hasMatchingType(spec, config) {
      if (isUnitSpec(spec)) {
        var mark = spec.mark,
          encoding = spec.encoding;
        var markDef = isMarkDef(mark) ? mark : {
          type: mark
        };
        switch (markDef.type) {
          case 'line':
          case 'rule':
          case 'trail':
            return !!getPointOverlay(markDef, config[markDef.type], encoding);
          case 'area':
            return (
              // false / null are also included as we want to remove the properties
              !!getPointOverlay(markDef, config[markDef.type], encoding) || !!getLineOverlay(markDef, config[markDef.type])
            );
        }
      }
      return false;
    }
  }, {
    key: "run",
    value: function run(spec, normParams, normalize) {
      var config = normParams.config;
      var params = spec.params,
        projection = spec.projection,
        mark = spec.mark,
        name = spec.name,
        e = spec.encoding,
        outerSpec = _objectWithoutProperties(spec, _excluded2);
      // Need to call normalizeEncoding because we need the inferred types to correctly determine stack
      var encoding = normalizeEncoding(e, config);
      var markDef = isMarkDef(mark) ? mark : {
        type: mark
      };
      var pointOverlay = getPointOverlay(markDef, config[markDef.type], encoding);
      var lineOverlay = markDef.type === 'area' && getLineOverlay(markDef, config[markDef.type]);
      var layer = [_objectSpread(_objectSpread({
        name: name
      }, params ? {
        params: params
      } : {}), {}, {
        mark: dropLineAndPoint(_objectSpread(_objectSpread({}, markDef.type === 'area' && markDef.opacity === undefined && markDef.fillOpacity === undefined ? {
          opacity: 0.7
        } : {}), markDef)),
        // drop shape from encoding as this might be used to trigger point overlay
        encoding: omit(encoding, ['shape'])
      })];
      // FIXME: determine rules for applying selections.
      // Need to copy stack config to overlayed layer
      // FIXME: normalizer shouldn't call `initMarkdef`, a method from an init phase.
      var stackProps = stack(initMarkdef(markDef, encoding, config), encoding);
      var overlayEncoding = encoding;
      if (stackProps) {
        var stackFieldChannel = stackProps.fieldChannel,
          offset = stackProps.offset;
        overlayEncoding = _objectSpread(_objectSpread({}, encoding), {}, _defineProperty({}, stackFieldChannel, _objectSpread(_objectSpread({}, encoding[stackFieldChannel]), offset ? {
          stack: offset
        } : {})));
      }
      // overlay line layer should be on the edge of area but passing y2/x2 makes
      // it as "rule" mark so that it draws unwanted vertical/horizontal lines.
      // point overlay also should not have y2/x2 as it does not support.
      overlayEncoding = omit(overlayEncoding, ['y2', 'x2']);
      if (lineOverlay) {
        layer.push(_objectSpread(_objectSpread({}, projection ? {
          projection: projection
        } : {}), {}, {
          mark: _objectSpread(_objectSpread({
            type: 'line'
          }, pick(markDef, ['clip', 'interpolate', 'tension', 'tooltip'])), lineOverlay),
          encoding: overlayEncoding
        }));
      }
      if (pointOverlay) {
        layer.push(_objectSpread(_objectSpread({}, projection ? {
          projection: projection
        } : {}), {}, {
          mark: _objectSpread(_objectSpread({
            type: 'point',
            opacity: 1,
            filled: true
          }, pick(markDef, ['clip', 'tooltip'])), pointOverlay),
          encoding: overlayEncoding
        }));
      }
      return normalize(_objectSpread(_objectSpread({}, outerSpec), {}, {
        layer: layer
      }), _objectSpread(_objectSpread({}, normParams), {}, {
        config: dropLineAndPointFromConfig(config)
      }));
    }
  }]);
}();